import {Injectable, Injector} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class TokenService {
  token: string
  userInfo = JSON.parse(localStorage.getItem('currentUser'));
  events: Subject<string> = new Subject<string>()

  constructor(private injector: Injector) {
  }

  init() {
    if (!this.token) return Promise.reject('No token');
    return Promise.resolve();
  }

  setToken(token: string) {
    this.token = this.userInfo['access_token'];
    localStorage.setItem("currentUser", JSON.stringify(this.userInfo)); 
  }
  
  logout() {
    const http = this.injector.get(HttpClient);
    //http.get(`/auth/Logout?token=${this.token}`).subscribe()
    this.token = null;
    localStorage.clear()
    this.events.next('logout')
  }


}



// WEBPACK FOOTER //
// ./src/app/_services/token/token.service.ts